module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.647ad0f2.ttf";